import React, { useState } from 'react';
import './AdminDashboard.css';
import UserManagement from './UserManagement';
import UserAnalytics from './UserAnalytics';
import { useAuth } from '../hooks/useAuth';

export default function AdminDashboard() {
  const [activeTab, setActiveTab] = useState('dashboard');
  const { logout, user } = useAuth();

  return (
    <div className="admin-dashboard">
      <nav className="admin-nav">
        <div className="admin-nav-header">
          <h2>Admin Panel</h2>
          <p>Welcome, {user?.username}</p>
        </div>
        <ul className="admin-nav-menu">
          <li>
            <button
              className={activeTab === 'dashboard' ? 'active' : ''}
              onClick={() => setActiveTab('dashboard')}
            >
              Dashboard
            </button>
          </li>
          <li>
            <button
              className={activeTab === 'users' ? 'active' : ''}
              onClick={() => setActiveTab('users')}
            >
              Users
            </button>
          </li>
          <li>
            <button
              className={activeTab === 'analytics' ? 'active' : ''}
              onClick={() => setActiveTab('analytics')}
            >
              Analytics
            </button>
          </li>
          <li>
            <button onClick={logout} className="logout-btn">
              Logout
            </button>
          </li>
        </ul>
      </nav>

      <div className="admin-content">
        {activeTab === 'dashboard' && (
          <div className="dashboard-tab">
            <h1>Admin Dashboard</h1>
            <div className="dashboard-info">
              <p>Welcome to the admin panel. Use the navigation to manage users and view analytics.</p>
            </div>
          </div>
        )}
        {activeTab === 'users' && <UserManagement />}
        {activeTab === 'analytics' && <UserAnalytics />}
      </div>
    </div>
  );
}
